import moment from 'moment'
require('moment/locale/zh-cn');

// 设置语言为中文
moment.locale('zh-cn');
/**
 * 获取当前时间
 */
export function updateCurrentTime() {
    return moment().format('YYYY-MM-DD HH:mm:ss dddd');
}
/**
 * 计算字体大小转变
 */
export function sumFontSize(fontSize) {
    const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);

    // 计算 12px 相对于根目录的大小
    const sizeInRem = fontSize / rootFontSize;
    return sizeInRem
}

export function bgImages() {
    return {
        '/login': require('@/assets/images/login/bg.webp'),
        '/travel': require('@/assets/images/travel/bg.png'),
        '/startPoint': require('@/assets/images/startPoint/bg.png'),
        '/chain': require('@/assets/images/login/bg.webp'),
        '/water': require('@/assets/images/water/bg.png'),
        '/index': require('@/assets/images/index/bg.png'),
        '/supply': require('@/assets/images/supply/bg.png'),
    }
}

export function localeFun(price) {
    let flag = 2
    if(price.toString().indexOf('.') == -1){
        flag = 0
    }
    return price > 0 ? new Intl.NumberFormat('ja-JP', {
        minimumFractionDigits: flag,
        maximumFractionDigits: flag
    }).format(price) : price
}

export function openFun() {
    if (!document.fullscreenElement) {
        // 进入全屏
        document.documentElement.requestFullscreen();
    } else {
        // 退出全屏
        if (document.exitFullscreen) {
            document.exitFullscreen(); // 标准化
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen(); // WebKit浏览器
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen(); // Firefox
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen(); // IE/Edge
        }
    }
}